import { useEffect } from "react";
import LText from "@components/LText";
import LBox from "@components/LBox";
import { fonts } from "@theme";
import { router } from "expo-router";
import { trackOnb } from "@components/Onboarding/analytics/trackOnboarding";
import IntroLayout from "@components/Onboarding/Intro/IntroLayout";
import Animated, { FadeIn } from "react-native-reanimated";

export default function Aha1() {
  useEffect(() => {
    trackOnb("signup", "aha-1", "view");
  }, []);

  return (
    <IntroLayout
      totalSteps={4}
      currentStep={1}
      buttonLabel="Tap to reveal"
      buttonEventName="aha_1"
      onButtonPress={() => router.navigate("/onboarding/aha-2")}
    >
      <LBox flex={1} justifyContent="center" alignItems="center">
        <Animated.View entering={FadeIn.duration(400).delay(300)}>
          <LText
            fontSize={24}
            fontFamily={fonts.semiBold}
            lineHeight={32}
            textAlign="center"
          >
            {"Some not-so-great news\nand some great news"}
          </LText>
        </Animated.View>
      </LBox>
    </IntroLayout>
  );
}
